import { IconCopy } from '@tabler/icons-react';
import { Button } from '@/admin/components/ui/button';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/admin/components/ui/card';
import type { AdminChatTraceResponse } from '../../types';

function copyText(value?: string | null) {
  if (!value) return;
  void navigator.clipboard?.writeText(value);
}

export function JsonBlock({ value }: { value: unknown }) {
  return (
    <pre className="max-h-[520px] overflow-auto rounded-md bg-muted p-3 text-xs">
      {JSON.stringify(value, null, 2)}
    </pre>
  );
}

export function RawTab({ trace }: { trace: AdminChatTraceResponse | null }) {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <CardTitle className="text-base">Raw</CardTitle>
          <Button
            variant="outline"
            size="sm"
            onClick={() => copyText(JSON.stringify(trace, null, 2))}
          >
            <IconCopy className="size-4" />
            Export JSON
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <JsonBlock value={trace || {}} />
      </CardContent>
    </Card>
  );
}
